import PropTypes from "prop-types"
import React, { Component } from "react"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"
import Icon from "semantic-ui-react/dist/es/elements/Icon/Icon"
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal"
import Loader from "../Loader"
import "./FaqLinks.css"

const API = null

const FaqModal = ({ label, onClose, content }) => (
  <Modal size="small" defaultOpen onClose={onClose}>
    <Modal.Header>{label}</Modal.Header>
    <Modal.Content>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={onClose} content="Got It!" primary />
    </Modal.Actions>
  </Modal>
)

class FaqLinks extends Component {
  state = {
    isModalOpen: false,
    linkId: "",
    linkLabel: "",
    content: "",
    showLoader: false
  }
  handleOpen = async (linkId, linkLabel) => {
    this.setState({ showLoader: true })
    try {
      const { content } = await API.getFaq(linkId)
      this.setState({ content, isModalOpen: true, linkLabel })
    } catch (error) {
      this.setState({
        content: `<div>We're sorry, but we couldn't locate this content.</div>`
      })
    } finally {
      this.setState({ showLoader: false })
    }
  }
  handleClose = () =>
    this.setState({ isModalOpen: false, linkId: null, linkLabel: null })
  render = () => {
    return (
      <div>
        {this.state.showLoader ? <Loader /> : null}
        <ul className="FaqLinks__List" style={{ paddingLeft: "0" }}>
          {this.props.items.map(link => (
            <li key={link.id}>
              <span
                className="FaqLinks__ListItem navlink"
                onClick={() => this.handleOpen(link.id, link.label)}
              >
                <Icon name="chevron right" size="small" />
                {link.label}
              </span>
            </li>
          ))}
        </ul>
        {this.state.isModalOpen ? (
          <FaqModal
            label={this.state.linkLabel}
            onClose={this.handleClose}
            faqId={this.state.linkId}
            content={this.state.content}
          />
        ) : null}
      </div>
    )
  }
}

FaqLinks.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired
    })
  ).isRequired
}

export default FaqLinks
